import { Flex, GimaTag, Text } from '@/components';
import type { FC } from 'react';

type Props = {
  name: string;
  isIntegrated: boolean;
};

export const UserName: FC<Props> = ({ name, isIntegrated }) => {
  return (
    <Flex gap={4}>
      <Text weight="regular" text={name} />
      <GimaTag isIntegrated={isIntegrated} />
    </Flex>
  );
};
